import { avg, product, sum, round } from "../math.ts";
Math.sum = sum;
Math.avg = avg;
Math.product = product;
Math.round = round;
//# sourceMappingURL=math.js.map